<template>
  <ProSpaceRightPanel
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="model" v-slot:center>
      <ProSpacePanelBlock :header="headerOrders">
        <template #header>
          <ProSpaceAction
            v-if="options.filter((o) => o.name === 'edit').length > 0"
            :text="$t('editItemTxt')"
            @click="editPanel"
          />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="model" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
  ProSpaceSimpleGrid,
  ProSpaceModal
} from "@prospace/prospace-components-library";
import { OrderService } from "../../../services/OrderService";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "OrderPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
    ProSpaceSimpleGrid,
    ProSpaceModal,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    model: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      order: null,
      orderService: new OrderService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerOrders() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.order) {
        return {
          title: this.order.marsPeriodName,
          id: this.order.id,
          status: this.getStatus(this.order.status),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: '',
        showCounter: false,
      };
    },
    content() {
      if (this.order) {
        return [
          [
            {
              title: this.$t("orderMarsPeriodName"),
              text: this.order.marsPeriodName,
            },
          ],
          [
            {
              title: this.$t("orderAgencyValue"),
              text: this.order.agencyValue,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.order) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.order.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.order.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.order.createdAt)  + ' ' + getAMorPM(this.order.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.order.lastUpdated)  + ' ' + getAMorPM(this.order.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    model() {
      this.update();
    },
  },
  methods: {
    update() {
      this.hasError = false;
      try {
        this.getOrder();
      } catch (e) {
        this.hasError = true;
      }
    },
    getOrder() {
      if (this.model) {
        this.loading = true;
        this.orderService.getById(this.model).then((res) => {
          this.order = res.data;
          this.loading = false;
        });
      }
      this.order = null;
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      switch (status) {
        case "created":
          type = "plan"
          break;
        case "published":
          type = "purple"
          break;
        case "approved":
          type = "blue-main"
          break;
        case "completed":
          type = "teal"
          break;
        case "deleted":
          type = "draft"
          break;
      }
      return {
        type: type,
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    editPanel() {
      this.$emit("edit", this.order);
    },
    deletePanel() {
      this.$emit("delete", this.order);
    },
    showHistoryPanel() {
      this.$emit("history", this.order);
    },
  },
};
</script>

<style scoped></style>
